import React, { useEffect } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import TimeLine from 'components/TimeLine';

import { getMbCommentsItem } from 'selectors';
import { DEFAULT_SOURCE_CURRENCY } from 'utils';
import { useIntl } from 'react-intl';
import { fetchMbComments } from 'actions';

const CurrencyMbTimeLine = () => {
  const params = useParams();
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentCurrency = params.currency || DEFAULT_SOURCE_CURRENCY;

  const mbCommentsData = useSelector(
    state => state?.currency?.mbComments?.data
  );

  useEffect(() => {
    if (!mbCommentsData) {
      dispatch(fetchMbComments({ intl }));
    }
  }, [dispatch, currentCurrency]);

  const data = useSelector(
    state => getMbCommentsItem(state, { currentCurrency }) || []
  );

  if (data.length === 0) {
    return null;
  }

  return <TimeLine data={data} currentCurrency={currentCurrency} />;
};

export default withRouter(CurrencyMbTimeLine);
